<template>
  <div id="store" class="store__recommend">
    <div class="store__recommend__header">
      <span class="store__recommend__header__title">店铺推荐</span>
      <el-button @click="clickMore" plain class="store__recommend__header__more">
        查看更多
        <i class="el-icon-arrow-right"></i>
      </el-button>
    </div>
    <div class="store__list">
      <StoreItem
        class="pointer"
        v-for="store in storeList"
        :key="store.storeId"
        :store="store"
        @click-store="linkToStoreDetails(store.storeId)"
      />
    </div>
  </div>
</template>

<script>
import StoreItem from './StoreItem';
export default {
  props: {
    storeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    storeLink: {
      type: String,
      default: ''
    }
  },
  components: {
    StoreItem
  },
  inject: ['home'],
  methods: {
    linkToStoreDetails(shopId) {
      const search = this.home.$refs.search;
      search && search.clear();
      this.$router.push({ path: `/store/${shopId}/homePage` });
    },
    clickMore() {
      window.open(this.storeLink);
    }
  }
};
</script>

<style lang="scss" scoped>
.store__recommend {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 32px;
    margin-bottom: 16px;
    &__title {
      font-size: 24px;
      font-weight: 500;
      color: #000000;
      line-height: 1;
    }
    &__more {
      padding-right: 0;
      font-size: 16px;
      font-weight: 400;
      color: #595959;
      line-height: 1;
      border: none;
    }
  }
  .store__list {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
